module.exports = __webpack_public_path__ + "static/media/automated-defect.cd0b5767.png";